import { render, staticRenderFns } from "./RegistrationComment.vue?vue&type=template&id=4139eaea&"
import script from "./RegistrationComment.vue?vue&type=script&lang=js&"
export * from "./RegistrationComment.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegistrationComment.vue"
export default component.exports